import React, { Suspense, lazy } from "react";
import MainApp from "./App";

const AUTOMATION_WAVE_ROUTE = "/automation-wave";

const AutomationWaveRoute = lazy(() =>
  import("./features/automation-wave/AutomationWaveRoute")
);

function normalizePath(pathname) {
  if (!pathname) return "/";
  const clean = pathname.replace(/\/+$/, "");
  return clean || "/";
}

function AutomationWaveLoading() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "#050811",
        color: "#F4F7FB",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      Loading Automation Wave…
    </div>
  );
}

export default function AutomationWaveEntry() {
  const pathname =
    typeof window !== "undefined"
      ? normalizePath(window.location.pathname)
      : "/";

  const isAutomationWave =
    pathname === AUTOMATION_WAVE_ROUTE ||
    pathname.startsWith(`${AUTOMATION_WAVE_ROUTE}/`);

  if (!isAutomationWave) {
    return <MainApp />;
  }

  return (
    <Suspense fallback={<AutomationWaveLoading />}>
      <AutomationWaveRoute />
    </Suspense>
  );
}
